module.exports = __webpack_public_path__ + "img/6.b7cfc90d.png";